import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Usage in routes:
 *   canActivate: [roleGuard('ADMIN')]
 *   canActivate: [roleGuard('USER')]
 */
export const roleGuard = (requiredRole: string): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router      = inject(Router);

    if (!authService.isLoggedIn) {
      return router.createUrlTree(['/login']);
    }

    if (authService.hasRole(requiredRole)) {
      return true;
    }

    // Logged in but wrong role — back to home
    return router.createUrlTree(['/']);
  };
};
